<!-- Young -->
<template>
  <div class="public-update">
    <div>
      <!-- v-if="audioType === 'AccessControl'" -->
      <div class="publicupdate-search">
        <a-input
          placeholder="请输入固件版本号"
          style="width: 85%;"
          v-model="searchVal"
        />
        <div>
          <a-button style="border-radius: 3px;" type="primary" @click="getList"
            >查询</a-button
          >
        </div>
      </div>
      <!-- <template v-else>
        <a-input-search
          placeholder="请输入固件版本号"
          style="width: 100%"
          v-model="searchVal"
          @search="getList"
        />
      </template> -->
    </div>
    <div
      class="list-wrap"
      :class="{ loadingHeight: scrollLoading }"
      v-infinite-scroll="scrollOnLoad"
      :infinite-scroll-disabled="busy"
      :infinite-scroll-distance="10"
    >
      <a-spin :spinning="listLoading" style="margin-top: 110px;" />
      <a-radio-group v-model="versionId">
        <a-radio
          :style="radioStyle"
          v-for="i in updateList"
          :key="i.id"
          :value="i.id"
          class="radio-row"
        >
          <!-- v-if="audioType === 'AccessControl'" -->
          <span>
            <a-row type="flex" justify="space-between">
              <a-col :span="6">
                {{ i.version }}
              </a-col>
              <a-col :span="6" style="color: #aaa;">
                {{ i.type }}
              </a-col>
              <a-col :span="12" class="upPackage-desc">
                <a-tooltip placement="topLeft" :title="i.remark">
                  {{ i.remark }}
                </a-tooltip>
              </a-col>
            </a-row>
          </span>
          <!-- <template v-else>
            <span>{{ i.version }}</span>
          </template> -->
        </a-radio>
      </a-radio-group>
    </div>
    <a-spin :spinning="scrollLoading" tip="加载列表中..." />
  </div>
</template>

<script>
export default {
  name: "PublicUpdate",
  props: {
    type: { required: true, type: String },
    updateServices: { required: true },
    audioType: { require: false, type: String, default: "" }, //新增设备类型用于筛选设备对应的版本号
    addesstype: { require: false, type: String, default: "" } //新增设备类型用于筛选设备版面列表
  },
  data() {
    return {
      radioStyle: {
        width: "100%",
        height: "60px",
        lineHeight: "60px",
        alignItems: "center",
        display: "flex"
      },
      busy: false,
      listLoading: false,
      scrollLoading: false,
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      searchVal: "",
      updateList: [],
      // 选择的固件id
      versionId: ""
    };
  },
  watch: {
    versionId() {
      if (this.versionId) {
        this.$emit("checkedVersion", this.versionId);
      }
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      this.updateList = [];
      this.listLoading = true;
      this.pageIndex = 1;
      this.updateList = await this.getVersionList();
      this.listLoading = false;
    },

    // 当前页面的固件列表
    async getVersionList() {
      let data = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        type: this.type
      };
      if (this.addesstype) {
        data.equType = this.addesstype;
      }
      if (this.searchVal.trim()) {
        data.name = this.searchVal.trim();
      }
      let res = await this.updateServices.listServices(data);

      if (res.status === 0) {
        this.total = res.result.total;
        return res.result.list;
      }
    },

    // 列表滚动加载
    async scrollOnLoad() {
      let listNum = this.updateList.length;
      // 总数大于10且现有列表长度小于总数
      if (this.total > 10 && listNum < this.total) {
        this.pageIndex += 1;
        this.scrollLoading = true;
        let list = await this.getVersionList();
        this.scrollLoading = false;
        this.updateList.push(...list);
      } else {
        this.busy = true;
      }
    }
  }
};
</script>
<style lang="less">
.public-update {
  .publicupdate-search {
    display: flex;
    justify-content: space-between;
  }
  .list-wrap {
    height: 272px;
    overflow-y: auto;
    padding: 16px 0;
    .ant-radio-group {
      width: 100%;
    }
    .radio-row {
      span.ant-radio + * {
        width: 95%;
        // padding-right: 0px;
        // padding-left: 0px;
      }

      .upPackage-desc {
        color: #aaa;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .item-wrap {
      height: 60px;
      line-height: 60px;
    }
  }
  .loadingHeight {
    height: 242px !important;
  }
  // .list-content {
  //   height: 240px;
  //   overflow-y: auto;
  // }
  .list-wrap::-webkit-scrollbar {
    width: 5px !important;
  }
  // loading-css
  .ant-spin {
    width: 310px !important;
    height: 30px !important;
  }
  .ant-spin-text {
    display: inline-block !important;
  }
}
</style>
